import { css } from '@/styled-system/css';

export const carouselHeaderStyles = css.raw({
  display: 'grid',
  alignItems: 'center',
  gridAutoFlow: 'column',
  gridGap: 'Carousel.Heading.gap.heading-toNav',
  justifyContent: 'space-between',
  paddingBlockEnd: 'Carousel.Heading.padding.headingArea-toSlideArray',
});
